import { render, staticRenderFns } from "./editBlogs.vue?vue&type=template&id=652e24ad&scoped=true&"
import script from "./editBlogs.vue?vue&type=script&lang=js&"
export * from "./editBlogs.vue?vue&type=script&lang=js&"
import style0 from "./editBlogs.vue?vue&type=style&index=0&id=652e24ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e24ad",
  null
  
)

export default component.exports